import React from "react";
import "../styles/Careers.css";

function Careers() {
    return (
        <div className="careers-container">

            {/* HERO SECTION */}
            <section className="careers-hero">
                <h1>Careers At Sahyadri Sahakari Bank Ltd</h1>
                <p>Build your future with integrity, purpose, and community impact.</p>
            </section>

            {/* SECTION 1 */}
            <section className="career-section">
                <div className="career-image">
                    <img
                        src="https://images.unsplash.com/photo-1521791136064-7986c2920216"
                        alt="Bank Team"
                    />
                </div>

                <div className="career-content">
                    <h2>Recruitment</h2>
                    <p>
                        At Sahyadri Sahakari Bank Ltd, we believe that our greatest strength lies in our people. We are committed to fostering a workplace where talent thrives, ideas flourish, and careers are built on a foundation of integrity, innovation, and community service. If you are passionate about banking, finance, and making a meaningful difference in people's lives, we invite you to explore the exciting career opportunities that await you at Sahyadri Sahakari Bank Ltd.

                        Why Work With Us?
                        Sahyadri Sahakari Bank Ltd has been a trusted financial institution serving the community with dedication and commitment for decades. Joining our team means becoming part of a legacy of trust, excellence, and cooperative banking values. We offer a dynamic and inclusive work environment where every employee is valued, respected, and empowered to grow both professionally and personally.
                    </p>
                    <h2>Why Work With Us?</h2>
                    <p>
                        Our employees are at the heart of everything we do. We invest in their development, recognize their contributions, and provide them with the tools and opportunities they need to succeed. At Sahyadri Sahakari Bank Ltd, you are not just an employee — you are a valued member of our banking family.
                    </p>
                </div>
            </section>

            {/* SECTION 2 */}
            <section className="career-section reverse">
                <div className="career-image">
                    <img
                        src="https://images.unsplash.com/photo-1551836022-d5d88e9218df"
                        alt="Office Work"
                    />
                </div>

                <div className="career-content">
                    <h2>Work With Purpose</h2>
                    <p>
                        At Sahyadri Sahakari Bank, your work directly contributes to
                        community development and financial empowerment. Every role
                        within our institution plays a part in strengthening trust,
                        supporting businesses, and improving lives.
                    </p>
                    <p>
                        When you join us, you don’t just start a job — you become part
                        of a mission rooted in cooperation, inclusion, and community growth.
                    </p>
                    <h2>Our Core Values</h2>
                    <p>
                        We are guided by a strong set of values that define who we are and how we work:
                        Integrity — We uphold the highest standards of honesty, transparency, and ethical conduct in everything we do.
                        Customer First — We are committed to delivering exceptional service and building lasting relationships with our customers and communities.
                        Teamwork — We believe in the power of collaboration and work together to achieve shared goals.
                        Innovation — We embrace new ideas, technologies, and approaches to continuously improve our services and operations.
                        Excellence — We strive for the highest level of performance and quality in all that we do.
                        Inclusivity — We celebrate diversity and foster an environment where everyone feels welcome, respected, and valued.
                    </p>
                </div>
            </section>

            {/* WHY JOIN US */}
            <section className="careers-why">
                <h2>Why Join Us</h2>

                <div className="why-grid">
                    <div className="why-card">
                        <h4>Growth & Learning</h4>
                        <p>Continuous training and professional development programs.</p>
                    </div>

                    <div className="why-card">
                        <h4>Supportive Culture</h4>
                        <p>A friendly environment focused on teamwork and respect.</p>
                    </div>

                    <div className="why-card">
                        <h4>Job Stability</h4>
                        <p>Long-term career opportunities in cooperative banking.</p>
                    </div>

                    <div className="why-card">
                        <h4>Community Impact</h4>
                        <p>Serve society while building your professional journey.</p>
                    </div>
                </div>
            </section>

            {/* RECRUITMENT PROCESS */}
            <section className="careers-process">
                <h2>Recruitment Process</h2>

                <div className="process-steps">
                    <div className="step">
                        <span>1</span>
                        <p>Submit Application</p>
                    </div>

                    <div className="step">
                        <span>2</span>
                        <p>Resume Screening</p>
                    </div>

                    <div className="step">
                        <span>3</span>
                        <p>Interview / Assessment</p>
                    </div>

                    <div className="step">
                        <span>4</span>
                        <p>Final Selection</p>
                    </div>
                </div>
            </section>

            {/* APPLY SECTION */}
            <section className="careers-apply">
                <h2>Ready to Join Us?</h2>
                <p>
                    Submit your application and upload your resume through the link below.
                </p>
                <p>This form is for general applications. For specific roles, visit the Job Openings page.</p>


                <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdXNmdQpGMTdpZNF7hC1KMp6EW8QnDBpUItI6nAhgfr1u19XA/viewform"
                    target="_blank"
                    rel="noreferrer"
                    className="apply-btn-careers"
                >
                    Apply for Careers
                </a>
                <p></p>
                <a
                   href="/job-posting"
                   className="apply-btn-careers"
                  >
                       Job Openings
                </a>

                <p className="careers-note">
                    We appreciate your interest in The Sahyadri Sahakari Bank!
                </p>
            </section>

        </div>
    );
}

export default Careers;